import type { CommonSVGProps } from './helpers';

export const SwigglyDivider = (props: CommonSVGProps) => (
  <svg fill="none" height={26} width={126} {...props}>
    <path
      d="M1.082 2.533c0 8.813-.092 14.73 8.876 18.914 9.328 4.353 32.8 6.314 31.69-9.789-.459-6.646-7.987-8.604-12.402-4.189-3.977 3.977-2.138 11.96 2.613 14.31 10.045 4.97 41.145-.537 35.173-17.172-1.451-4.044-7.79-5.167-9.54-.87-1.686 4.138-1.243 6.476 2.406 9.083 11.822 8.444 37.24 9.346 40.898-8.13 1.428-6.822-8.768-1.791-8.628 3.401.273 10.097 11.103 10.896 18.914 11.448 8.465.599 16.145-5.9 13.19-14.766"
      stroke="#DCDCDC"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
